const getCurrencyByCountry = (country?: string | null) => {
  switch (country) {
    case 'GB':
      return 'GBP'
    case 'AU':
      return 'AUD'
    default:
      return 'EUR'
  }
}

export default getCurrencyByCountry
